export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      portfolio: "Portfolio",
      process: "Process",
      reviews: "Reviews",
      contact: "Contact",
      quote: "Get a Free Quote",
    },
    common: {
      callNow: "Call Now",
      requestEstimate: "Request a Free Estimate",
      openNow: "Open Now · Closes 8:00 PM",
      rating: "5.0 Stars · 2,387 Reviews",
      address: "4912 Haverwood Ln, Dallas, TX 75287",
      phoneLabel: "Phone",
      serveArea: "Serving Dallas, TX and surrounding areas",
      seHablaEspanol: "Se habla español",
      learnMore: "Learn more",
      viewAll: "View all services",
    },
    hero: {
      overline: "Dallas, Texas · Remodeling & Painting",
      title: "Premium Painting, Remodeling & Home Improvement.",
      subtitle:
        "Commercial and residential transformations — kitchens, bathrooms, flooring, drywall, cabinets, and full home remodels. Signature craftsmanship, on time, every time.",
      trustBadge: "Rated 5.0 by 2,387 homeowners",
    },
    about: {
      overline: "About GA Signature",
      title: "Signature craftsmanship for Dallas homes and businesses.",
      body:
        "GA Signature is a full-service remodeling contractor in Dallas, TX, delivering premium painting, electrical, drywall, flooring, cabinet, kitchen, bathroom, and general contracting services. We blend modern design sensibility with uncompromising workmanship — the result is spaces that feel intentional, durable, and distinctly yours.",
      stat1: { k: "2,387", v: "Five-star reviews" },
      stat2: { k: "12+", v: "Years in Dallas, TX" },
      stat3: { k: "100%", v: "Licensed & insured" },
      stat4: { k: "24/48h", v: "Estimate turnaround" },
    },
    services: {
      overline: "What we do",
      title: "A complete remodeling & painting studio.",
      subtitle:
        "From a single accent wall to a full home transformation — one trusted team, one signature standard.",
      items: [
        { title: "Bathroom Remodeling", desc: "Spa-quality bathrooms with curated tile, lighting, and fixtures." },
        { title: "Kitchen Remodeling", desc: "Designer kitchens built for daily life — cabinetry, stone, and layout." },
        { title: "Full Home Remodels", desc: "Whole-home transformations from design to final walkthrough." },
        { title: "Interior & Exterior Painting", desc: "Flawless finishes, premium paints, sharp lines — inside and out." },
        { title: "Drywall Installation & Repair", desc: "Smooth walls, invisible seams, and textured finishes done right." },
        { title: "Flooring Installation & Repair", desc: "Hardwood, LVP, tile, and laminate — precision-fit and sealed." },
        { title: "Cabinet Installation", desc: "Custom and pre-fab cabinetry installed to millimeter tolerances." },
        { title: "Tile Replacement", desc: "Bathrooms, kitchens, entryways — tile with a fine-art finish." },
        { title: "Waterproofing", desc: "Protect kitchens, baths, and basements with proven systems." },
        { title: "Design & Build", desc: "Design-led remodeling — one team from concept to completion." },
        { title: "Commercial & Residential", desc: "Retail, offices, and homes — handled with the same signature care." },
        { title: "General Contractor", desc: "Licensed GC coordination across trades, permits, and timelines." },
      ],
    },
    whyUs: {
      overline: "Why homeowners choose us",
      title: "Work with a signature crew.",
      points: [
        { k: "5.0", v: "Average rating across 2,387 verified reviews." },
        { k: "Residential & Commercial", v: "Equally at home in a Highland Park kitchen or a Deep Ellum storefront." },
        { k: "Quality craftsmanship", v: "Tradespeople who care about lines, levels, and finish details." },
        { k: "Reliable scheduling", v: "We show up on time and communicate every step." },
        { k: "Clean, professional work", v: "Protected floors, daily cleanup, respectful crews." },
        { k: "Complete solutions", v: "From permits to paint — you only need one contractor." },
      ],
    },
    gallery: {
      overline: "Portfolio",
      title: "Recent transformations.",
      subtitle: "A selection of kitchens, bathrooms, full home remodels, and commercial spaces across Dallas.",
    },
    process: {
      overline: "How we work",
      title: "Four steps. One signature outcome.",
      steps: [
        { n: "01", t: "Consultation", d: "We listen first — budget, lifestyle, and the details that matter to you." },
        { n: "02", t: "Design & Estimate", d: "Scope, materials, and a transparent fixed-price estimate within 24–48 hours." },
        { n: "03", t: "Professional Construction", d: "A dedicated project lead, vetted trades, and weekly progress updates." },
        { n: "04", t: "Final Walkthrough", d: "Punch-list, deep clean, and a warranty you can count on." },
      ],
    },
    reviews: {
      overline: "Reviews",
      title: "Homeowners and businesses trust us.",
      subtitle: "5.0 stars across 2,387 reviews.",
      items: [
        {
          name: "Maria H., North Dallas",
          role: "Kitchen & Living Remodel",
          text:
            "Absolutely flawless. The team handled demo, cabinetry, stone, and paint without a single hiccup. Our kitchen looks like a showroom.",
        },
        {
          name: "Daniel R., Plano, TX",
          role: "Master Bath Remodel",
          text:
            "GA Signature turned our 1990s bathroom into a spa. Tile work was immaculate. Communication was constant. Worth every dollar.",
        },
        {
          name: "Jordan L., Uptown Dallas",
          role: "Commercial Office Paint & Drywall",
          text:
            "They repainted and refinished our entire office over one weekend — zero downtime. Professional, clean, and fast.",
        },
      ],
    },
    area: {
      overline: "Service area",
      title: "Serving Dallas, TX and surrounding areas.",
      body:
        "Based at 4912 Haverwood Ln, Dallas, TX 75287 — we serve North Dallas, Plano, Frisco, Addison, Carrollton, Richardson, Highland Park, University Park, Uptown, Oak Lawn, and the greater DFW metroplex.",
    },
    contact: {
      overline: "Contact",
      title: "Request a free estimate.",
      subtitle:
        "Tell us about your project. We typically respond within a few hours during business hours.",
      fields: {
        name: "Full name",
        phone: "Phone number",
        email: "Email address",
        service: "Service needed",
        details: "Project details",
      },
      placeholders: {
        name: "e.g. Alex Johnson",
        phone: "e.g. (214) 555-0199",
        email: "e.g. alex@example.com",
        details: "Tell us about your space, scope, timing, and budget range.",
      },
      submit: "Request Free Estimate",
      submitting: "Sending…",
      success: "Thanks! Your request was received. We'll be in touch shortly.",
      error: "We couldn't send your request. Please call us at (254) 550-0122.",
    },
    footer: {
      tagline: "Painting · Electrical · Remodeling",
      about: "Dallas, TX's signature remodeling and painting contractor. Licensed. Insured. Detail-obsessed.",
      servicesTitle: "Services",
      companyTitle: "Company",
      contactTitle: "Contact",
      copyright: "© GA Signature. All rights reserved.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      portfolio: "Portafolio",
      process: "Proceso",
      reviews: "Reseñas",
      contact: "Contacto",
      quote: "Cotización gratis",
    },
    common: {
      callNow: "Llamar ahora",
      requestEstimate: "Solicitar cotización gratis",
      openNow: "Abierto · Cierra 8:00 PM",
      rating: "5.0 Estrellas · 2,387 Reseñas",
      address: "4912 Haverwood Ln, Dallas, TX 75287",
      phoneLabel: "Teléfono",
      serveArea: "Atendemos Dallas, TX y áreas cercanas",
      seHablaEspanol: "Se habla español",
      learnMore: "Más información",
      viewAll: "Ver todos los servicios",
    },
    hero: {
      overline: "Dallas, Texas · Remodelación y Pintura",
      title: "Pintura, remodelación y mejoras del hogar de alta gama.",
      subtitle:
        "Transformaciones comerciales y residenciales — cocinas, baños, pisos, drywall, gabinetes y remodelaciones completas. Mano de obra premium, a tiempo y con garantía.",
      trustBadge: "Calificados 5.0 por 2,387 clientes",
    },
    about: {
      overline: "Sobre GA Signature",
      title: "Mano de obra signature para casas y negocios en Dallas.",
      body:
        "GA Signature es un contratista integral de remodelación en Dallas, TX. Ofrecemos pintura, electricidad, drywall, pisos, gabinetes, cocinas, baños y servicios de contratista general. Combinamos diseño moderno con excelente trabajo manual — espacios duraderos, intencionales y únicos.",
      stat1: { k: "2,387", v: "Reseñas 5 estrellas" },
      stat2: { k: "12+", v: "Años en Dallas, TX" },
      stat3: { k: "100%", v: "Licencia y seguro" },
      stat4: { k: "24/48h", v: "Cotización rápida" },
    },
    services: {
      overline: "Qué hacemos",
      title: "Un estudio completo de remodelación y pintura.",
      subtitle:
        "Desde una pared de acento hasta la transformación total de la casa — un equipo confiable, un estándar signature.",
      items: [
        { title: "Remodelación de baños", desc: "Baños estilo spa con azulejo, iluminación y accesorios cuidadosamente elegidos." },
        { title: "Remodelación de cocinas", desc: "Cocinas de diseñador para el día a día — gabinetes, piedra y distribución." },
        { title: "Remodelación total", desc: "Transformaciones de casa completa desde el diseño hasta la entrega final." },
        { title: "Pintura interior y exterior", desc: "Acabados impecables, pinturas premium y líneas perfectas." },
        { title: "Instalación y reparación de drywall", desc: "Paredes lisas, uniones invisibles y texturas bien hechas." },
        { title: "Instalación y reparación de pisos", desc: "Madera, LVP, azulejo y laminado — cortes precisos y sellado." },
        { title: "Instalación de gabinetes", desc: "Gabinetes a medida o prefabricados instalados con tolerancia milimétrica." },
        { title: "Reemplazo de azulejo", desc: "Baños, cocinas y entradas — azulejo con acabado de alta gama." },
        { title: "Impermeabilización", desc: "Protege cocinas, baños y sótanos con sistemas probados." },
        { title: "Diseño y construcción", desc: "Remodelación guiada por diseño — un equipo desde el concepto hasta la entrega." },
        { title: "Comercial y residencial", desc: "Locales, oficinas y casas — el mismo cuidado signature." },
        { title: "Contratista general", desc: "Coordinación con licencia: oficios, permisos y cronogramas." },
      ],
    },
    whyUs: {
      overline: "Por qué nos eligen",
      title: "Trabaja con un equipo signature.",
      points: [
        { k: "5.0", v: "Calificación promedio en 2,387 reseñas verificadas." },
        { k: "Residencial y comercial", v: "Igual de cómodos en una cocina de Highland Park que en un local de Deep Ellum." },
        { k: "Artesanía de calidad", v: "Oficiales que cuidan líneas, niveles y detalles de acabado." },
        { k: "Cronograma confiable", v: "Llegamos a tiempo y comunicamos cada paso." },
        { k: "Trabajo limpio", v: "Pisos protegidos, limpieza diaria y equipos respetuosos." },
        { k: "Soluciones completas", v: "De permisos a pintura — un solo contratista." },
      ],
    },
    gallery: {
      overline: "Portafolio",
      title: "Transformaciones recientes.",
      subtitle: "Una selección de cocinas, baños, remodelaciones completas y espacios comerciales en Dallas.",
    },
    process: {
      overline: "Cómo trabajamos",
      title: "Cuatro pasos. Un resultado signature.",
      steps: [
        { n: "01", t: "Consulta", d: "Escuchamos primero — presupuesto, estilo de vida y los detalles que importan." },
        { n: "02", t: "Diseño y cotización", d: "Alcance, materiales y cotización cerrada en 24–48 horas." },
        { n: "03", t: "Construcción profesional", d: "Líder de proyecto dedicado, oficiales calificados y reportes semanales." },
        { n: "04", t: "Entrega final", d: "Lista de detalles, limpieza profunda y garantía que respalda el trabajo." },
      ],
    },
    reviews: {
      overline: "Reseñas",
      title: "Familias y empresas confían en nosotros.",
      subtitle: "5.0 estrellas en 2,387 reseñas.",
      items: [
        {
          name: "María H., Norte de Dallas",
          role: "Cocina y sala",
          text:
            "Perfecto. El equipo manejó demolición, gabinetes, piedra y pintura sin contratiempos. La cocina parece un showroom.",
        },
        {
          name: "Daniel R., Plano, TX",
          role: "Baño principal",
          text:
            "GA Signature convirtió nuestro baño de los 90 en un spa. El azulejo quedó impecable. Comunicación constante.",
        },
        {
          name: "Jordan L., Uptown Dallas",
          role: "Oficina: pintura y drywall",
          text:
            "Repintaron y arreglaron toda la oficina en un fin de semana — cero tiempo caído. Profesionales y rápidos.",
        },
      ],
    },
    area: {
      overline: "Área de servicio",
      title: "Atendemos Dallas, TX y áreas cercanas.",
      body:
        "Ubicados en 4912 Haverwood Ln, Dallas, TX 75287 — atendemos Norte de Dallas, Plano, Frisco, Addison, Carrollton, Richardson, Highland Park, University Park, Uptown, Oak Lawn y el metroplex DFW.",
    },
    contact: {
      overline: "Contacto",
      title: "Solicita una cotización gratis.",
      subtitle:
        "Cuéntanos sobre tu proyecto. Normalmente respondemos en pocas horas durante el horario comercial.",
      fields: {
        name: "Nombre completo",
        phone: "Teléfono",
        email: "Correo electrónico",
        service: "Servicio requerido",
        details: "Detalles del proyecto",
      },
      placeholders: {
        name: "p. ej. Alex Johnson",
        phone: "p. ej. (214) 555-0199",
        email: "p. ej. alex@ejemplo.com",
        details: "Cuéntanos sobre el espacio, alcance, tiempos y rango de presupuesto.",
      },
      submit: "Solicitar cotización gratis",
      submitting: "Enviando…",
      success: "¡Gracias! Recibimos tu solicitud. Te contactaremos pronto.",
      error: "No pudimos enviar tu solicitud. Llámanos al (254) 550-0122.",
    },
    footer: {
      tagline: "Pintura · Electricidad · Remodelación",
      about: "Contratista signature de remodelación y pintura en Dallas, TX. Con licencia. Asegurados. Obsesionados con los detalles.",
      servicesTitle: "Servicios",
      companyTitle: "Compañía",
      contactTitle: "Contacto",
      copyright: "© GA Signature. Todos los derechos reservados.",
    },
  },
};
